import { PRODUCT_ENTITLEMENTS } from '@headline/schemas'
import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { buttonVariants } from '@/components/ui/button'
import { WorkspaceApiPage } from '@/components/workspace-api/WorkspaceApiPage'
import { accountQuery } from '@/lib/queries'
import { prefetchWorkspaceUsage, workspaceApiQuery } from '@/lib/workspace-api-queries'

/**
 * A client workspace's API & MCP: its endpoint and keys. A disabled product redirects to the
 * client's Home, the workspace you're in.
 */
export const Route = createFileRoute('/app/accounts/$accountId_/subaccounts/$subaccountId/api')({
  loader: async ({ context, params }) => {
    const account = await context.queryClient.ensureQueryData(accountQuery(params.accountId))
    if (!account.entitlements.includes(PRODUCT_ENTITLEMENTS.api)) {
      throw redirect({
        to: '/app/accounts/$accountId/subaccounts/$subaccountId',
        params: { accountId: params.accountId, subaccountId: params.subaccountId },
      })
    }
    const api = await context.queryClient.ensureQueryData(workspaceApiQuery(params.subaccountId))
    prefetchWorkspaceUsage(context.queryClient, params.subaccountId, api.endpoint)
  },
  component: ClientApiPage,
})

function ClientApiPage() {
  const { accountId, subaccountId } = Route.useParams()
  return (
    <WorkspaceApiPage
      accountId={accountId}
      subaccountId={subaccountId}
      referenceLink={
        <Link
          to="/app/accounts/$accountId/subaccounts/$subaccountId/api/reference"
          params={{ accountId, subaccountId }}
          className={buttonVariants({ variant: 'outline', size: 'sm' })}
        >
          API reference
        </Link>
      }
    />
  )
}
